// extracted by mini-css-extract-plugin
export default {"Icon":"FacebookButton_Icon__WkD1G"};